import WebSocketClient from '@clients/web-socket.client';
import { INativeReviewRequest, INewRating } from '@app-types/websocket/rating.types';

const socket = WebSocketClient.getInstance();

export function submitRating(data: INewRating) {
  socket.sendJSON({
    rating: data,
  });
}

export function recordNativeReviewRequest(data: INativeReviewRequest) {
  socket.sendJSON({
    rating: data,
  });
}



// WEBPACK FOOTER //
// ./src/services/rating/rating.websocket.ts